console.log("App initialized");

document.addEventListener("DOMContentLoaded", function() {
  // Funcionalidad del menú hamburguesa para móvil
  const hamburgerBtn = document.getElementById("hamburgerBtn");
  const mainNav = document.getElementById("mainNav");
  const overlayNav = document.getElementById("overlayNav");
  const hamburgerIcon = document.getElementById("hamburgerIcon");

  if (hamburgerBtn && mainNav && overlayNav && hamburgerIcon) {
    function openNav() {
      mainNav.classList.remove("t-translate-x-[-225px]");
      mainNav.classList.add("t-translate-x-0");
      overlayNav.classList.remove("t-opacity-0", "t-pointer-events-none");
      overlayNav.classList.add("t-opacity-50", "t-pointer-events-auto");
      hamburgerIcon.classList.remove("fa-bars");
      hamburgerIcon.classList.add("fa-times");
    }

    function closeNav() {
      mainNav.classList.add("t-translate-x-[-225px]");
      mainNav.classList.remove("t-translate-x-0");
      overlayNav.classList.add("t-opacity-0", "t-pointer-events-none");
      overlayNav.classList.remove("t-opacity-50", "t-pointer-events-auto");
      hamburgerIcon.classList.remove("fa-times");
      hamburgerIcon.classList.add("fa-bars");
    }

    hamburgerBtn.addEventListener("click", function() {
      const isOpen = mainNav.classList.contains("t-translate-x-0");
      if (isOpen) {
        closeNav();
      } else {
        openNav();
      }
    });

    overlayNav.addEventListener("click", function() {
      closeNav();
    });
  }

  // Funcionalidad del menú desplegable de Catálogos
  const catalogosToggle = document.getElementById("catalogosToggle");
  const catalogosMenu = document.getElementById("catalogosMenu");
  const catalogosArrow = document.getElementById("catalogosArrow");

  if (catalogosToggle && catalogosMenu && catalogosArrow) {
    catalogosToggle.addEventListener("click", function() {
      const isHidden = catalogosMenu.classList.contains("t-hidden");

      if (isHidden) {
        catalogosMenu.classList.remove("t-hidden");
        catalogosMenu.classList.add("t-block");
        catalogosArrow.classList.add("t-rotate-180");
      } else {
        catalogosMenu.classList.add("t-hidden");
        catalogosMenu.classList.remove("t-block");
        catalogosArrow.classList.remove("t-rotate-180");
      }
    });
  }
});